import { SettingsPartyContainer } from 'src/containers/SoftwareEscrow/Settings';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';

const SettingsDepositor = () => {
  return <SettingsPartyContainer partyType={EscrowPartyTypeEnum.Depositor} />;
};

export default SettingsDepositor;
